module.exports = __webpack_public_path__ + "img/coinbankB08.d87dddd6.jpg";